import {useEffect, useRef, useState} from 'react';

/**
 * @param {string} sessionId
 * @param {boolean} hasInteracted
 * @returns {{setCustomerReading: (function(*, *): Promise<void>), emptySoundNotification: (function(): Promise<void>), emptyMessageNotification: (function(): Promise<void>), refreshTimeoutNotificationMessage: (function(): void), notificationMessage: {}}}
 */
export default function useNotificationMessage({sessionId, hasInteracted}) {
  const [instance, setInstance] = useState(null);
  const [data, setData] = useState({});
  const isInit = useRef(false);
  const {id: notiId} = data;

  useEffect(() => {
    if (sessionId && hasInteracted && !isInit.current) {
      initNotificationMessage().then();
      isInit.current = true;
    }
  }, [sessionId, hasInteracted]);

  const initNotificationMessage = async () => {
    const {default: NotificationMessageService} = await import(
      '@scripttag/service/notificationMessageService'
    );
    const newInstance = new NotificationMessageService();
    setInstance(newInstance);
    await newInstance.listenNotificationMessage({setData});
  };

  const setCustomerReading = (convoId, isReading) => {
    instance?.handleCustomerReading({convoId, notiId, isReading, setData}).then();
  };
  const emptySoundNotification = () => instance?.emptySound(notiId);
  const emptyMessageNotification = () => instance?.emptyMessages(notiId);
  const refreshTimeoutNotificationMessage = () => instance?.refreshTimeout();

  return {
    setCustomerReading,
    notificationMessage: data,
    emptySoundNotification,
    emptyMessageNotification,
    refreshTimeoutNotificationMessage
  };
}
